module.exports = __webpack_public_path__ + "static/media/whatsapp-open.67d9c820.svg";